import { FEATURE_TOGGLE_STATE } from '@/constants';
import { FeatureToggleEntity } from '@/types';
import { atomWithUniqueKey } from '@/utils';

export type FeatureToggleState = {
  isLoaded: boolean;
  isLoading: boolean;
  features: FeatureToggleEntity[];
};

export const useFeatureToggleState = atomWithUniqueKey<FeatureToggleState>({
  key: FEATURE_TOGGLE_STATE,
  default: { features: [], isLoaded: false, isLoading: false },
});
